import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { schedulesStateSelector } from "./schedulesStateSelector";

export const currentOffHoursSelector = createDraftSafeSelector(
  [schedulesStateSelector],
  (schedules) => schedules.offHours,
);
